<template>
  <div v-if="emptyObj?.code !== 5209">
    <!-- styles 图搜 -->
    <div
      v-if="type === 'discovery'"
      class="ai-discovery-breadcrumb-wrapper"
    >
      <BreadCrumb class="ai-discovery-breadcrumb">
        <BreadCrumbItem to="/">
          Home
        </BreadCrumbItem>
        <BreadCrumbItem>Ai Discovery</BreadCrumbItem>
      </BreadCrumb>
    </div>
    <div
      v-if="type === 'discovery'"
      class="find-styles-wrapper"
    >
      <h2>Results for <span>"Similar items"</span></h2>

      <!-- 查询关键词 -->
      <div
        v-if="checkedAttributes.length"
        class="find-styles-filters"
      >
        <div
          v-for="(item, index) in checkedAttributes"
          :key="index"
          class="find-styles-filters-item"
        >
          {{ item.en }}
          <img
            @click="handleRemoveFilter(item)"
            src="@/assets/images/icon-close-light.svg"
            alt=""
          >
        </div>
        <div
          @click="handleCleanFilter"
          class="find-styles-filters-item clean"
        >
          Clean
          <Icon name="icon-trash-l" />
        </div>
      </div>
      <Product :product-list="productList" />
    </div>
    <!-- similar 图搜 -->
    <main
      v-if="type === 'similar'"
      class="main-container"
    >
      <!-- canvas list -->
      <div
        v-if="!!canvasImgSelectList?.length"
        class="canvas-list"
      >
        <CImage
          class="canvas-main"
          :src="currentMainImage"
        />
        <div class="canvas-line" />
        <div class="canvas-line-item-list">
          <div class="canvas-line-item-list-title">
            Relate similar searches
          </div>
          <div class="canvas-line-item-list-content">
            <div
              v-for="(item, index) in canvasImgSelectList"
              :class="{
                'canvas-list-item': true,
                'select-item': initSelected === index,
              }"
              @click="selectImg(item, index)"
            >
              <img
                class="canvas-body-border-img"
                src="@/assets/item_body_border.svg"
                alt=""
              >
              <div class="canvas-list-item-img">
                <img
                  :src="item.imgUrl"
                  alt=""
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <h2 v-if="productList.length">
        Results for <span>"Similar items"</span>
      </h2>
      <Product :product-list="productList" />
    </main>
    <!-- 文搜 -->
    <TextSearch
      v-if="(categoryId || keyword)"
    />
  </div>

  <Empty
    v-if="emptyObj?.code === 5209"
    :msg="emptyObj?.msg || 'Sorry, no results found'"
  />
  <!-- <SiderBar
    v-if="type === 'discovery'"
    v-model="showDrawerForAiDiscovery"
    :size="sideBarWidth"
    direction="left">
    <PCDiscovery
      @filterChange="handleDiscoveryFilterChange"
      @collapse="collapseSideBar"
      @discovery-finish="handleDiscoveryFinish"
      :mainImage="currentMainImage"
      :imageList="canvasImgSelectList"
    />
  </SiderBar> -->
</template>

<script setup>
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import Product from '@/components/Product/index.vue'
import { fetchData } from '@/utils/fetch'
import { buriedPointUtil, gaAnalytics } from '@/utils/utils'
import Empty from '@/components/Empty/index.vue'
import SiderBar from '@/components/AiDiscovery/components/SiderBar.vue'
import PCDiscovery from '@/components/AiDiscovery/PCDiscovery.vue'
import BreadCrumb from '@/components/BreadCrumb/BreadCrumb.vue'
import BreadCrumbItem from '@/components/BreadCrumb/BreadCrumbItem.vue'
import { TextSearch } from './TextSearch'
import Icon from '@/components/Icon/Icon.vue'
import { Image as CImage } from '@/components/Image'

const store = useStore()
const route = useRoute()
const router = useRouter()

const showDrawerForAiDiscovery = ref(true)
const topFiveProductList = ref([])

const currentMainImage =
  sessionStorage.getItem(`currentMainImage_${route.query.imageId}`) ||
  sessionStorage.getItem(`currentMainImage_${route.query.offerId}`) ||
  ''
const initSelected = ref(0)

const keyword = computed(() => route.query.keyword)
const categoryId = ref(route.query.categoryId)
const type = computed(() => route.query.type)
const imageId = computed(() => route.query.imageId)
const offerId = computed(() => route.query.offerId)

const searchInfo = computed(() => store.state.searchInfo)
const productList = computed(() => store.state.productList)
const canvasImgSelectList = computed(() => store.state.canvasImgSelectList)
const emptyObj = computed(() => store.state.emptyObj)
const checkedAttributes = computed(() => store.state.discoveryCheckedAttributes)

const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

const calculateCropDimensions = (picRegionInfo) => {
  const regions = picRegionInfo?.yoloCropRegion?.split(';')

  // 将每个区域的字符串分割并转换为对象
  const result = regions.map((region) => {
    const [x0, y0, x1, y1] = region.split(',').map(Number)
    return {
      x0,
      y0,
      x1,
      y1
    }
  })

  return result
}

const searchByImgId = async (pageNow = 1) => {
  store.commit('setProductList', [])
  store.commit('setTotal', -1)
  store.commit('setInitSkeleton', true)

  const searchData = {
    ...searchInfo.value,
    keyword: '',
    pageNow: type.value === 'discovery' ? pageNow : 1,
    pageSize: 50
  }
  if (offerId.value) {
    searchData.imageAddress = currentMainImage
  }
  if (imageId.value) {
    searchData.imageId = imageId.value
  }
  try {
    const { code, data } = await fetchData('/dsp-app/alibaba-common/searchImage', {
      method: 'post',
      body: JSON.stringify(searchData)
    })
    if (code === 200) {
      const { picRegionInfo } = data

      const coordinates = calculateCropDimensions(picRegionInfo)

      cutImageByCoordinates(currentMainImage, coordinates, picRegionInfo).then(list => {
        store.dispatch('setImgSearch', {
          ...data,
          canvasImgList: list,
          searchInfo: {
            ...searchInfo.value,
            keyword: '',
            imageId,
            pageNow: 1,
            pageSize: 50,
            region: picRegionInfo?.currentRegion
          },
          currentMainImage
        })
        if (window.location.pathname.includes('/offer')) {
          router.replace('/')
        }
        store.commit('setLoading', false)
        store.commit('setInitSkeleton', false)
      })
    }
  } catch (error) {
    console.log(error, 'error')
  }
}

// 根据坐标裁剪图片
const cutImageByCoordinates = async (imgUrl, coordinates, picRegionInfo) => {
  const response = await fetch(imgUrl)
  const blob = await response.blob()
  const base64Image = await blobToBase64(blob)

  const image = new Image()
  image.src = base64Image
  const list = []

  return new Promise((resolve) => {
    image.onload = () => {
      const canvas = document.getElementById('canvas')
      const ctx = canvas.getContext('2d')

      coordinates.forEach((coord, index) => {
        const width = coord.y0 - coord.x0
        const height = coord.y1 - coord.x1

        canvas.width = width
        canvas.height = height

        ctx.clearRect(0, 0, canvas.width, canvas.height) // 清空画布
        ctx.drawImage(
          image,
          coord.x0,
          coord.x1,
          width,
          height,
          0,
          0,
          width,
          height
        )
        list.push({
          imgUrl: canvas.toDataURL(),
          region: picRegionInfo?.yoloCropRegion?.split(';')[index]
        })
      })

      resolve(list)
    }
  })
}

const searchByOfferId = async () => {
  const type = route.query.type
  store.commit('setProductList', [])
  store.commit('setTotal', -1)

  store.commit('setInitSkeleton', true)
  await fetchData('/dsp-app/alibaba-common/searchImage', {
    method: 'post',
    body: JSON.stringify({
      ...searchInfo.value,
      imageAddress: currentMainImage, // 主图，来源于点击find style时的sessionStorage缓存。
      imageId: 0,
      pageNow: 1,
      pageSize: 50
    })
  }).then(async (res) => {
    const fetchData = res.data || []
    const { picRegionInfo } = fetchData

    const coordinates = calculateCropDimensions(picRegionInfo)
    const list = await cutImageByCoordinates(currentMainImage, coordinates, picRegionInfo)
    if (type === 'similar') {
      store.dispatch('setImgSearch', {
        ...fetchData,
        canvasImgList: list, // 将主图转为base64，然后根据坐标裁剪，返回裁剪后的图片列表
        searchInfo: {
          keyword: '',
          imageId: 0,
          pageNow: 1,
          pageSize: 50,
          region: picRegionInfo?.currentRegion,
          imageAddress: currentMainImage
        },
        currentMainImage
      })
      store.commit('setInitSkeleton', false)
    }
    if (type === 'discovery') {
      // 取图搜前十个商品用于ai discovery
      localStorage.setItem('aiDiscoveryProductList', JSON.stringify(fetchData.rows.slice(0, 10)))
      // 取图搜前五个商品随机插入视图展示
      topFiveProductList.value = fetchData.rows.slice(0, 5)
      store.commit('setCanvasImgSelectList', list)
    }
    store.commit('setLoading', false)
  })
}

// 切换图片
const selectImg = async (item, index) => {
  const searchInfoObj = {
    ...searchInfo.value,
    region: item.region,
    pageSize: 50,
    pageNow: 1
  }
  initSelected.value = index
  gaAnalytics('p_search_click', 'p_search_click')
  buriedPointUtil({ eventId: 'PSI201' })
  store.commit('setProductList', [])
  store.commit('setTotal', -1)
  store.commit('setInitSkeleton', true)

  const { code, data } = await fetchData('/dsp-app/alibaba-common/searchImage', {
    method: 'post',
    body: JSON.stringify(searchInfoObj)
  })
  if (code === 200) {
    store.dispatch('setImgSearch', { ...data, searchInfo: searchInfoObj })
  }
  store.commit('setLoading', false)
  store.commit('setInitSkeleton', false)
}

const sideBarWidth = ref(312)
const aiProductName = ref('') // ai 提供的商品名称
const collapseSideBar = (collapse) => {
  // 收缩侧边栏
  sideBarWidth.value = collapse ? 80 : 312
}

const handleDiscoveryFilterChange = () => {
  document.documentElement.scrollTop = 0
  const keywords = checkedAttributes.value.map(item => item.cn).join('') + aiProductName.value
  handleDiscoveryFinish(keywords)
}

const handleDiscoveryFinish = async (keywords, productName = '') => {
  if (productName) {
    aiProductName.value = productName
  }
  const searchData = {
    keyword: keywords,
    language: 'zh',
    pageSize: 50,
    pageNow: 1,
    imageId: 0,
    region: '',
    async: false
  }

  store.commit('setProductList', [])
  store.commit('setTotal', -1)
  store.commit('setInitSkeleton', true)
  const res = await fetchData('/dsp-app/alibaba-common/searchKeyWord?itemNumber=50', {
    method: 'post',
    body: JSON.stringify(searchData)
  })
  if (res.code === 200) {
    store.commit('setInitSkeleton', false)

    const { rows = [], total } = res.data
    const currencyData = JSON.parse(localStorage.getItem('currencyData'))
    const list = rows.map((v) => {
      return {
        ...v,
        priceInfo: { price: v.priceInfo.price, ...currencyData }
      }
    })

    // 将前五个图搜商品打乱插入到list中
    topFiveProductList.value.forEach(product => {
      const randomIndex = Math.floor(Math.random() * (list.length + 1))
      list.splice(randomIndex, 0, product)
    })

    store.commit('setSearchInfo', searchData)
    store.commit('setProductList', list)
    store.commit('setTotal', total)
  }
}

const handleRemoveFilter = (item) => {
  store.commit('SET_DISCOVERY_CHECKED_ATTRIBUTES', checkedAttributes.value.filter(v => v.en !== item.en))
  const keywords = checkedAttributes.value.map(item => item.cn).join('') + aiProductName.value
  handleDiscoveryFinish(keywords)
}

const handleCleanFilter = () => {
  store.commit('SET_DISCOVERY_CHECKED_ATTRIBUTES', [])
  handleDiscoveryFinish(aiProductName.value)
}

// 标品搜索
watch(
  () => offerId.value,
  (val) => {
    if (val) {
      searchByOfferId()
    }
  },
  { immediate: true }
)
// 图片搜索
watch(
  () => imageId.value,
  (val) => {
    if (val) {
      searchByImgId()
    }
  },
  { immediate: true }
)
</script>

<style scoped lang="less">
@import "./index.less";
</style>
